import { render, staticRenderFns } from "./CarouselProductCard.vue?vue&type=template&id=4720bd6e&scoped=true&"
import script from "./CarouselProductCard.vue?vue&type=script&lang=js&"
export * from "./CarouselProductCard.vue?vue&type=script&lang=js&"
import style0 from "./CarouselProductCard.vue?vue&type=style&index=0&id=4720bd6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4720bd6e",
  null
  
)

export default component.exports